import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const paymentPlanWizard: IMcAppType = {
  name: "paymentPlanWizard",
  path: "/my/payment-plan-wizard",
  description: "Wizard for helping with customer payment settings",
  navFlow: NavFlow.STANDARD,
  title: "Payment Plan Wizard",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "paymentPlanWizard",
    customerType: CustomerType.kraken,
  },
};
